export function getImageSize() {
  const currentWindow = window.innerWidth
  const shouldReturnCurrentWindow = currentWindow <= 1039

  return shouldReturnCurrentWindow
    ? {
        width: `${currentWindow * 3}`,
        height: '600',
      }
    : {
        width: '1040',
        height: '236',
      }
}

export function getThumbnailUrl({
  height = 150,
  width = 150,
  quality = 80,
  originalSrc,
}: {
  height?: number | string
  width?: number | string
  quality?: number
  originalSrc: string
}) {
  if (!originalSrc || /^(blob|data):/i.test(originalSrc)) {
    return `${originalSrc}`
  }
  const assetKey = originalSrc.replace('https://ik.imagekit.io/avantstay/', '')

  return `https://imglite.avantstay.com/${width}x${height}/${quality}/${assetKey}`
}
